import { ReactElement } from 'react'

const Edit = ({ ...props }): ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            width="20"
            height="20"
            viewBox="0 0 12 16"
            className="edit-icon"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    transform="translate(-1398.000000, -315.000000)"
                    fill="currentColor"
                >
                    <g transform="translate(975.000000, 0.000000)">
                        <g transform="translate(0.000000, 38.000000)">
                            <g transform="translate(17.000000, 239.000000)">
                                <path d="M416.883378,39.8868696 L409.67893,47.0910435 L408.916015,46.3281304 L416.113551,39.1174348 C416.177725,39.053 416.252594,39.0434783 416.291595,39.0434783 C416.330464,39.0434783 416.405334,39.053 416.469638,39.1173043 L416.883378,39.5310435 C416.981465,39.6291304 416.981465,39.7887826 416.883378,39.8868696 L416.883378,39.8868696 Z M407.926666,47.3477391 L408.65971,48.0807826 L407.448491,48.5550435 L407.926666,47.3477391 Z M417.62138,38.7933043 L417.207509,38.3795652 C416.962944,38.1347391 416.637769,38 416.291725,38 L416.291464,38 C415.945159,38.0001304 415.619724,38.1351304 415.375028,38.3802174 L407.130751,46.6396087 C407.080403,46.6898261 407.041142,46.7499565 407.014925,46.816087 L406.036662,49.2861304 C405.960227,49.4793043 406.005488,49.6993478 406.152097,49.8463478 C406.25188,49.9466522 406.385576,50 406.52188,50 C406.585793,50 406.650228,49.9882609 406.712055,49.964 L409.190059,48.9938261 C409.257103,48.9676087 409.317886,48.9276957 409.368755,48.8769565 L417.621249,40.6247391 C418.126163,40.120087 418.126294,39.2984783 417.62138,38.7933043 L417.62138,38.7933043 Z" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Edit
